import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import React from 'react';

interface IDisplayTipsCheckbox {
	settingsId: string;
	isTipsSupported: boolean;
	onToggleDisplayTips: () => void;
}

const DisplayTipsCheckbox: React.FC<IDisplayTipsCheckbox> = ({ settingsId, onToggleDisplayTips, isTipsSupported }) => {
	return (
		<Form.Item data-test="DisplayTipsCheckbox" name={`isTipsSupported-${settingsId}`}>
			<Checkbox checked={isTipsSupported} onChange={onToggleDisplayTips}>
				<Text translationNameSpace="form" translationKey="bankSettingsDisplayTipsLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(DisplayTipsCheckbox);
